import { useState } from 'react';
import { FiChevronRight, FiLayers, FiLoader } from 'react-icons/fi';
import { DOMAIN_PP, DOMAIN_PR, DOMAIN_LABELS } from '../../utils/domain';

const OPTIONS = [DOMAIN_PP, DOMAIN_PR];

/**
 * Karta "Poziom nauki" — zwinięty wiersz z chevronem, po rozsunięciu dwa kafelki wyboru.
 * Jedno źródło wyglądu dla modala roadmapy i ustawień.
 *
 * value    — poziom pokazywany jako aktywny (PP/PR)
 * onSelect — wywoływane tylko dla poziomu innego niż aktywny
 * isSaving — zamienia ikonę aktywnego kafelka na spinner
 * hint     — opcjonalna linijka pod kafelkami
 */
const DomainLevelCard = ({ value, onSelect, isSaving = false, hint }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="group bg-white rounded-xl border border-gray-200 shadow-[0_2px_8px_rgba(0,0,0,0.07)] hover:shadow-[0_4px_16px_rgba(35,56,85,0.12)] active:scale-[0.99] transition-all duration-150 overflow-hidden">
      <button
        type="button"
        onClick={() => setIsExpanded(v => !v)}
        className="w-full p-3.5 flex items-center gap-3"
      >
        <div className="flex-shrink-0 p-2 rounded-xl shadow-md bg-[#233855] text-[#F8AB3B] text-xl">
          <FiLayers />
        </div>
        <div className="flex-1 text-left">
          <p className="text-[10px] text-gray-400 font-semibold uppercase tracking-wider leading-none mb-0.5">
            Poziom nauki
          </p>
          <p className="text-[15px] font-bold font-apotek text-[#233855] leading-none tracking-wide">
            {DOMAIN_LABELS[value]?.full || DOMAIN_LABELS[DOMAIN_PP].full}
          </p>
        </div>
        <div className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 ${isExpanded ? 'bg-[#233855]/10' : 'bg-gray-100 group-hover:bg-[#233855]/10'}`}>
          <FiChevronRight className={`w-4 h-4 transition-all duration-200 ${isExpanded ? 'text-[#233855] rotate-90' : 'text-gray-400 group-hover:text-[#233855] group-hover:translate-x-0.5'}`} />
        </div>
      </button>

      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isExpanded ? 'max-h-80' : 'max-h-0'}`}>
        <div className="px-4 pb-4">
          <div className="grid grid-cols-2 gap-2.5">
            {OPTIONS.map((domain) => {
              const isSelected = value === domain;
              return (
                <button
                  key={domain}
                  type="button"
                  onClick={() => !isSelected && onSelect(domain)}
                  disabled={isSaving}
                  className={`flex flex-col items-center p-3 rounded-xl border transition-all active:scale-95 relative overflow-hidden disabled:cursor-default ${
                    isSelected
                      ? "border-[#233855] bg-white shadow-md ring-1 ring-[#233855]/20"
                      : "border-gray-200 bg-gray-50 opacity-70 hover:opacity-100"
                  }`}
                >
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg mb-1.5 shadow-sm ${
                    isSelected ? "bg-[#233855] text-[#F8AB3B]" : "bg-white text-gray-400 border border-gray-100"
                  }`}>
                    {isSaving && isSelected
                      ? <FiLoader className="animate-spin" size={16} />
                      : <FiLayers />
                    }
                  </div>
                  <span className={`text-[10px] font-bold uppercase text-center leading-tight ${isSelected ? "text-[#233855]" : "text-gray-500"}`}>
                    {DOMAIN_LABELS[domain].label}
                  </span>
                  {isSelected && <div className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-[#E09F2E] rounded-full" />}
                </button>
              );
            })}
          </div>

          {hint && (
            <p className="mt-2.5 text-[11px] text-gray-400 leading-snug">
              {hint}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DomainLevelCard;
